import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Palmtree, LogIn, ArrowLeft, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Login() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    fetch(`${API}/auth/me`, { credentials: "include" })
      .then((r) => { if (r.ok) navigate("/espace-leads", { replace: true }); else setChecking(false); })
      .catch(() => setChecking(false));
  }, [navigate]);

  const login = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/espace-leads";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-ocean-dark flex items-center justify-center px-6 relative overflow-hidden" data-testid="login-page">
      <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-ocean-lagoon/25 blur-[120px]" />
      <div className="absolute -bottom-24 -left-24 w-96 h-96 rounded-full bg-gold/15 blur-[120px]" />

      <div className="relative w-full max-w-md rounded-[2rem] bg-white/[0.04] border border-white/10 backdrop-blur-xl p-8 sm:p-10 text-center">
        <div className="inline-flex items-center gap-2 font-serif text-2xl font-semibold text-white">
          <Palmtree className="w-6 h-6 text-gold" strokeWidth={1.6} /> L'Échappée CSE
        </div>
        <h1 className="mt-6 font-serif text-3xl font-semibold text-white leading-tight">Espace Équipe CSE</h1>
        <p className="mt-3 text-sm text-white/60 leading-relaxed">
          Connectez-vous avec votre compte Google autorisé pour consulter et suivre les demandes de proposition reçues.
        </p>

        {checking ? (
          <div className="mt-8 flex items-center justify-center text-white/60"><Loader2 className="w-6 h-6 animate-spin" /></div>
        ) : (
          <button
            onClick={login}
            className="mt-8 w-full inline-flex items-center justify-center gap-3 rounded-full bg-white hover:bg-white/90 text-ocean-dark font-semibold px-6 py-4 transition-all hover:-translate-y-0.5"
            data-testid="google-login-button"
          >
            <LogIn className="w-5 h-5" /> Se connecter avec Google
          </button>
        )}

        <button
          onClick={() => navigate("/")}
          className="mt-6 inline-flex items-center gap-1.5 text-sm text-white/50 hover:text-gold transition-colors"
          data-testid="back-home-button"
        >
          <ArrowLeft className="w-4 h-4" /> Retour au site
        </button>
      </div>
    </div>
  );
}
